// TODO: delete this PageLoaderDeprecated after all old pages will be deleted
import React from 'react';
import PropTypes from 'prop-types';

import useResponsive from '../../hooks/useResponsive';
import Loader from './Loader';

import styles from '../../styles/views/components/PageLoaderDeprecated.module.scss';

const PageLoaderDeprecated = ({ text }) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();

  return (
    <div className={styles.wrapper}>
      {isMobile && <Loader width="100px" height="100px" />}
      {isTablet && <Loader width="120px" height="120px" /> }
      {isDesktop && <Loader width="180px" height="180px" /> }
      <div className={styles.text}>{text || t('components.defaultLoadingPageText', { ns: i18next.Namespace.COMMON })}</div>
    </div>
  );
};

PageLoaderDeprecated.propTypes = {
  text: PropTypes.string,
};

PageLoaderDeprecated.defaultProps = {
  text: '',
};

export default PageLoaderDeprecated;
